<h1 mat-dialog-title>Attach a file</h1>

<form [formGroup]="fileForm">
  <mat-dialog-content aria-live="polite">
    <mat-card appearance="outlined" class="af-mat-card mat-elevation-z">
      <mat-card-header>
        <div mat-card-avatar class="example-header-image">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="img-size" aria-label="file attachment icon">
            <g data-name="ICON OUTLINES">
              <path fill="#012169" d="M12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Zm0,19a9,9,0,1,1,9-9A9.01,9.01,0,0,1,12,21Z" transform="translate(-2 -2)"/>
              <path fill="#012169" d="M11.992,6.848a.632.632,0,0,0-.617.64.625.625,0,0,0,1.25,0A.635.635,0,0,0,11.992,6.848Z" transform="translate(-2 -2)"/>
            <rect fill="#012169" x="9.5" y="7" width="1" height="8"/></g>
          </svg>
        </div>
        <mat-card-title class="zoom-text-dialog">Allowed file formats</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{this.fileFormat}}</p>
      </mat-card-content>
    </mat-card>

    @if (descOfFileName.value == '4' || descOfFileName.value == '35') {
      <p class="bofa--heading is-9 global-red"
        aria-live="polite">
        If you are attaching Court Documents or Credit Documents, please ensure you have answered the questions on
        the Criminal History page accurately and have provided all relevant Offense/Regulatory Action Details.
      </p>
    }

    @if (!ousAttachments) {
      <div class="padd-15">
        <mat-form-field class="max-zoom-dialog" hideRequiredMarker>
          <mat-label><abbr title="required">* </abbr>File description</mat-label>
          <mat-select formControlName="descOfFileName" required>
            <mat-option>Select</mat-option>
            @for (descOfFileName of fileDescriptionLookup | keyvalue  : valueAscOrder; track descOfFileName) {
              <mat-option
                [value]="descOfFileName.key">
                {{descOfFileName.value}}
              </mat-option>
            }
          </mat-select>
          @if (fileForm.controls.descOfFileName.hasError('required') ) {
            <mat-error>Please select File description
            </mat-error>
          }
        </mat-form-field>
      </div>
    }

    <div class="padd-15">
      <app-file-upload [descOfFileName]="descOfFileName" [ousAttachments]="ousAttachments"
        [ousAttachmentId]="ousAttachmentId" [verifyId]="verifyId" [fileFormat]="fileFormat"
      [ousAttachmentDesc]="ousAttachmentDesc" [updateFlag]="updateFlag"></app-file-upload>
    </div>

  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <div class="is-taller">
      <div class="level">
        <div class="level-item">
          <button class="bofa--button secondary outlined" type="button" (click)="onNoClick()">Cancel</button>
        </div>

        <div class="level-item">
          <button class="bofa--button secondary" type="button" [disabled]="fileForm.invalid || inProgress"
          (click)="uploadClick()">Upload</button>
        </div>
      </div>
    </div>
  </mat-dialog-actions>
</form>